import type { ReactNode } from "react";

import { FormikProps, FormikValues, getIn } from "formik";

import { DotNotationPath } from "./FormikField.types";

export const getFieldPath = <T extends FormikValues>(
  path?: DotNotationPath<T> | string,
  fieldName?: string
): string => {
  const fieldPath = path ?? fieldName;

  if (!fieldPath) {
    throw new Error("Either path or fieldName must be provided");
  }

  return fieldPath;
};

export const getFieldValue = <T extends FormikValues>(formik: FormikProps<T>, fullPath: string): unknown => {
  return getIn(formik.values, fullPath) ?? "";
};

export const hasFieldError = <T extends FormikValues>(formik: FormikProps<T>, fullPath: string): boolean => {
  return !!getIn(formik.errors, fullPath);
};

export const getFieldHelperText = <T extends FormikValues>(
  formik: FormikProps<T>,
  fullPath: string,
  helperText?: ReactNode
): ReactNode => {
  return (getIn(formik.errors, fullPath) as ReactNode) ?? helperText;
};

export const getFieldError = <T extends FormikValues>(formik: FormikProps<T>, fullPath: string): string | undefined => {
  const error: unknown = getIn(formik.errors, fullPath);
  return typeof error === "string" ? error : undefined;
};
